export { default as NikoInsuranceManagementEditTemplate } from './NikoInsuranceManagementEditTemplate';
export { default as NikoInsuranceManagementListTemplate } from './NikoInsuranceManagementListTemplate';
